export { howItWorkAddText } from './howItWorkAddText';
export { techniqueAddText } from './techniqueAddText';
export { whyUseAddText } from './whyUseAddText';
